import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';

/**
 * Popup "Chọn hợp đồng/văn bản"
 *
 * Nghiệp vụ (theo tài liệu đặc tả):
 * - Icon: hiển thị icon tài liệu như ảnh thiết kế.
 * - Label: "Chọn hợp đồng/văn bản".
 * - Dropdown "Phiên bản sử dụng": mặc định chọn "vContract",
 *   KHÔNG cho phép người dùng chỉnh sửa (readonly).
 * - Icon X (góc trên phải) và button "Hủy bỏ": đóng popup,
 *   trở về màn hình trước đó. Mặc định enable.
 * - Button "Tiếp tục": gọi API filter hợp đồng/văn bản đủ điều kiện,
 *   sau đó chuyển đến popup chọn hợp đồng/văn bản cần rà soát.
 *
 * Điều kiện lọc hợp đồng/văn bản (BE áp dụng, FE chỉ gọi API):
 * - contract.status = 4 (Hoàn thành), không lấy hợp đồng lao động.
 * - Chưa có trong danh sách rà soát.
 * - Luồng ký chỉ có 1 KH ký kết là KHCN.
 *
 * Mở popup này bằng MatDialog, ví dụ:
 *   const ref = this.dialog.open(SelectVersionDialogComponent);
 *   ref.afterClosed().subscribe((contracts) => { ... });
 */
@Component({
  selector: 'app-select-version-dialog',
  templateUrl: './select-version-dialog.component.html',
  styleUrls: ['./select-version-dialog.component.scss'],
})
export class SelectVersionDialogComponent {
  /** Giá trị dropdown mặc định, không cho chỉnh sửa theo đặc tả */
  readonly selectedVersion = 'vContract';

  isLoading = false;
  errorMessage = '';

  constructor(
    private dialogRef: MatDialogRef<SelectVersionDialogComponent>,
    private http: HttpClient,
    private documentTypeService: DocumentTypeService,
  ) {}

  /** Đóng popup - dùng chung cho nút X và nút "Hủy bỏ" */
  onCancel(): void {
    this.dialogRef.close();
  }

  /** Xử lý khi bấm "Tiếp tục" */
  /** Xử lý khi bấm "Tiếp tục" */
onContinue(): void {
    // Không gọi API filter ở đây nữa -> đóng popup ngay, việc gọi API chuyển sang màn tiếp theo
    this.dialogRef.close({ selectedVersion: this.selectedVersion });
  }
}